import React from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import AlertIcon from '@mui/icons-material/Warning';
import QuestionIcon from '@mui/icons-material/Help';
import InfoIcon from '@mui/icons-material/Info';
import ErrorIcon from '@mui/icons-material/Error';
import ImportantIcon from '@mui/icons-material/Star';

const CommentContainer = styled.div<{ bgColor: string }>`
  background-color: ${({ bgColor }) => bgColor};
  padding: 5px;
  margin: 5px 0;
  border-radius: 4px;
  border-left: 6px solid ${({ bgColor }) => bgColor};
`;

const CommentTitle = styled.div`
  font-weight: bold;
  margin-left: 8px;
`;

interface CommentProps {
  type?: string;
  color?: string;
  title: string;
  text: string;
}

const getIcon = (type: string) => {
  switch (type) {
    case 'Alerta':
      return <AlertIcon />;
    case 'Questão':
      return <QuestionIcon />;
    case 'Informação':
      return <InfoIcon />;
    case 'Erro':
      return <ErrorIcon />;
    case 'Importante':
      return <ImportantIcon />;
    default:
      return null;
  }
};

const getBackgroundColor = (type: string) => {
  switch (type) {
    case 'Alerta':
      return '#fff3cd';
    case 'Questão':
      return '#d1ecf1';
    case 'Informação':
      return '#d4edda';
    case 'Erro':
      return '#f8d7da';
    case 'Importante':
      return '#fff8e1';
    default:
      return 'yellow'; // Default background color for generic comments
  }
};

const Comment: React.FC<CommentProps> = ({ type, color, title, text }) => {
  const bgColor = type ? getBackgroundColor(type) : color || 'yellow';
  const icon = type ? getIcon(type) : null;

  return (
    <CommentContainer bgColor={bgColor}>
      <div style={{ display: 'flex', alignItems: 'center', color: color }}>
        {icon}
        <CommentTitle>{title}</CommentTitle>
      </div>
      <div>{parse(text)}</div>
    </CommentContainer>
  );
};

export default Comment;
